import Vue from 'vue'
import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";

function getDataErr(res) {
    if(!res) return false;
    return ['data','message'].reduce((tmp, key) =>
       tmp.hasOwnProperty(key) ? tmp[key] : tmp
    ,res);
}

export let initAxios = (urlApi) => {
    Vue.use(VueAxios, axios);

    Vue.axios.defaults.baseURL = urlApi;
    Vue.axios.defaults.headers['Content-Type'] = 'x-www-form-urlencoded';

    Vue.axios.interceptors.response.use(function (res) {
        if(res.status !== 200) return Promise.reject(`Error status #${res.status}`);
        if(!res.data || res.data.status !== "success") return Promise.reject(getDataErr(res));

        if(res.data.hasOwnProperty('info')) res.data = res.data.info;
        if(res.data.hasOwnProperty('data')) res.data = res.data.data;
        return res;
    }, function (err) {
        return Promise.reject(getDataErr(err.response) || err.toString());
    });
    /*Vue.axios.interceptors.response.use(null, function (err,a,b,c) {
        store.commit('notifications/putNotification', {message: err.message});
        return err;
    });*/
};

export let initAuth = () => {
    Vue.use(VueAuth, {
        auth: {
            request: function (req, token) {
                if(token) {
                    req.url += `&token=${token}`
                }
            },
            response: function (res) {
                const headers = this.options.http.getHeaders.call(this, res);
                if(headers.Authorization || headers.authorization) {
                    return btoa(headers.Authorization || headers.authorization);
                }
            }
        },
        http: require('@websanova/vue-auth/drivers/http/axios.1.x.js').default,
        router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js').default,

        loginData: {
            method: 'GET',
            url: 'api.php?method=cabinet&type=auth',
            fetchUser: true,
            redirect: {name: 'profile'}
        },
        fetchData: {
            url: 'api.php?method=cabinet&type=getUser',
            method: 'GET',
            enabled: true
        },
        refreshData: {
            enabled: false
        },
        logoutData: {
            makeRequest: false,
            redirect: {name: 'login'}
        },
        parseUserData(data){
            return data || {};
        }
    });
}